import config from "config";

export function createHSNURL() {
  return `${config.apiUrl}/create_hsn`;
}

export function mobileExistCheckUrl() {
  return `${config.apiUrl}/mobile/checkMobileNoExists`;
}
